import Image from 'next/image'

import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { AppModal } from '@/components/shared/modal'

type Props = {
  opened: boolean
  onClose: () => void
  text: string
  headerText: string
  bottomText?: string
  imageSrc?: string
  imageClassName?: string
}

export const ErrorModal = ({
  opened,
  onClose,
  text,
  headerText,
  bottomText,
  imageSrc = '/images/shared/Blocked.png',
  imageClassName
}: Props) => (
  <AppModal
    overlayClassName="!bg-black/50"
    className="mx-16 w-[480px] sm:!h-auto sm:!rounded-16"
    headerWrapperClassName="!pb-12"
    header={headerText}
    opened={opened}
    onClose={onClose}
  >
    <div className="flex flex-col items-center gap-y-20 text-center">
      <Image
        src={imageSrc}
        width={140}
        height={140}
        alt="blocked"
        className={cn('rotate-12', imageClassName)}
      />
      <div className="flex flex-col">
        <p className="text-grey-70 text-20 xxs:w-[310px] xxs:text-18">{text}</p>
        {bottomText && (
          <p className="text-grey-70 text-20 xxs:w-[310px] xxs:text-18">
            {bottomText}
          </p>
        )}
      </div>
      <AppButton variant="secondary" className="!h-56" fluid onClick={onClose}>
        Понятно
      </AppButton>
    </div>
  </AppModal>
)
